module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-dialog', {
    staticStyle: {
      "width": "1024px"
    },
    attrs: {
      "open": _vm.dialog,
      "dialogClass": "coverPhotoDialog"
    },
    on: {
      "close": _vm.close
    }
  }, [(!_vm.isCropperVisible) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.isUploading) ? _c('div', [_c('h2', [_vm._v("Just a moment")])]) : _vm._e(), _vm._v(" "), (!_vm.isUploading) ? _c('mu-raised-button', {
    attrs: {
      "icon": "photo",
      "label": "Select image"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('vue-base64-file-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "disable-preview": "",
      "placeholder": "Tap to change cover photo",
      "accept": "image/png,image/jpeg",
      "max-size": _vm.customImageMaxSize
    },
    on: {
      "size-exceeded": _vm.onSizeExceeded,
      "load": _vm.onLoad
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCropperVisible && _vm.isCropperVisible),
      expression: "isCropperVisible && isCropperVisible"
    }],
    ref: "imageCropper"
  }), _vm._v(" "), _c('mu-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isUploading && _vm.isCropperVisible),
      expression: "!isUploading && isCropperVisible"
    }],
    attrs: {
      "align": "center"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "tooltip": "Cancel",
      "icon": "close",
      "label": "Cancel"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "tooltip": "Rotate left",
      "icon": "rotate_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.rotate('left')
      }
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "tooltip": "Rotate right",
      "icon": "rotate_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.rotate('right')
      }
    }
  }), _vm._v(" "), _c('mu-circular-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUploading),
      expression: "isUploading"
    }],
    attrs: {
      "size": 16
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "secondary": "",
      "icon": "crop",
      "label": _vm.isUploading ? 'Uploading...' : 'Crop & Upload'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doCrop()
      }
    }
  })], 1), _vm._v(" "), (_vm.isUploading) ? _c('div', [_vm._v("Uploading...")]) : _vm._e(), _vm._v(" "), (_vm.isUploading) ? _c('mu-linear-progress', {
    attrs: {
      "mode": "determinate",
      "value": _vm.completionPercentage
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8ea2bd2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/AddProfileCover/AddProfileCover.vue
// module id = 3319
// module chunks = 1